import React from 'react';
import {NavLink} from 'react-router-dom';
import {
    getClosest,
    getSiblings,
    slideToggle,
    slideUp,
} from "../../../utils";

const MobileNavMenu = () => {
    const onClickHandler = (e) => {
        const target = e.currentTarget;
        const parentEl = target.parentElement;
        if (
            parentEl?.classList.contains("menu-toggle") ||
            target.classList.contains("menu-toggle")
        ) {
            const element = target.classList.contains("icon")
                ? parentEl
                : target;
            const parent = getClosest(element, "li");
            const childNodes = parent.childNodes;
            const parentSiblings = getSiblings(parent);
            parentSiblings.forEach((sibling) => {
                const sibChildNodes = sibling.childNodes;
                sibChildNodes.forEach((child) => {
                    if (child.nodeName === "UL") {
                        slideUp(child, 1000);
                    }
                });
            });
            childNodes.forEach((child) => {
                if (child.nodeName === "UL") {
                    slideToggle(child, 1000);
                }
            });
        }
    };
    return (
        <nav className="site-mobile-menu">
            <ul>
                <li className="">
                    <NavLink to={process.env.PUBLIC_URL + "/"}><span className="menu-text">Home</span></NavLink>
                    {/* <span className="menu-toggle" onClick={onClickHandler}><i className="icon fa fa-angle-down"></i></span> */}
                    {/* <ul className="sub-menu">
                        <li><NavLink to={process.env.PUBLIC_URL + "/home-one"}><span className="menu-text">Home One</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/home-two"}><span className="menu-text">Home Two</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/home-three"}><span className="menu-text">Home Three</span></NavLink></li>
                    </ul> */}
                </li>
                <li className="has-children">
                    <NavLink to={process.env.PUBLIC_URL + "/about"}><span className="menu-text">About Us</span></NavLink>
                    <span className="menu-toggle" onClick={onClickHandler}><i className="icon fa fa-angle-down"></i></span>
                    <ul className="sub-menu">
                        <li><NavLink to={process.env.PUBLIC_URL + "/about"}><span className="menu-text">About</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/About-advantages"}><span className="menu-text">Advantages</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/Gallery"}><span className="menu-text">Gallery</span></NavLink></li>
                       </ul>
                </li>
                <li className="has-children">
                    <NavLink to={process.env.PUBLIC_URL + "/Service/defence"}><span className="menu-text">Products</span></NavLink>
                    <span className="menu-toggle" onClick={onClickHandler}><i className="icon fa fa-angle-down"></i></span>
                    <ul className="sub-menu">
                        <li><NavLink to={process.env.PUBLIC_URL + "/Service/defence"}><span className="menu-text">Defence Components</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/service/surgical"}><span className="menu-text">Surgical Instruments</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/service/oilandgas"}><span className="menu-text">Oil And Gas Industry Parts</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/service/automobile"}><span className="menu-text">Automobile Parts</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/service/machine"}><span className="menu-text">Machine Tools</span></NavLink></li>
                    </ul>
                </li>
                <li className="has-children">
                    <NavLink to={process.env.PUBLIC_URL + "/testing-facility"}><span className="menu-text">In-House Facilities</span></NavLink>
                    <span className="menu-toggle" onClick={onClickHandler}><i className="icon fa fa-angle-down"></i></span>
                    <ul className="sub-menu">
                        <li><NavLink to={process.env.PUBLIC_URL + "/testing-facility"}><span className="menu-text">Testing Facilities</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + `/in-house-facilities/machining`}><span className="menu-text">Machining Facility</span></NavLink></li>
                    </ul>
                </li>
                <li className="has-children">
                    <NavLink to={process.env.PUBLIC_URL + "/quality-certificate"}><span className="menu-text">Quality Certificate</span></NavLink>
                    <span className="menu-toggle" onClick={onClickHandler}><i className="icon fa fa-angle-down"></i></span>
                    <ul className="sub-menu">
                        <li><NavLink to={process.env.PUBLIC_URL + "/blog-grid"}><span className="menu-text">Quality Certificate</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/Material"}><span className="menu-text">Material</span></NavLink></li>
                        {/* <li><NavLink to={process.env.PUBLIC_URL + `/blog-details/1`}><span className="menu-text">Blog Details</span></NavLink></li> */}
                    </ul>
                </li>
                <li>
                    <NavLink to={process.env.PUBLIC_URL + "/csr"}><span className="menu-text">CSR</span></NavLink>
                    
                </li>
                <li>
                    <NavLink to={process.env.PUBLIC_URL + "/contact"}><span className="menu-text">Contact Us</span></NavLink>
                </li>
            </ul>
        </nav>
    )
}

export default MobileNavMenu;
